module.exports = __webpack_public_path__ + "img/5-3.d868ff82.svg";